import { useRef, useState, useEffect } from 'react';

export default function Reveal({ children, delay = 0 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const reduce = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.15 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={ref} style={{
      opacity: visible ? 1 : 0,
      transform: visible || reduce ? 'translateY(0)' : 'translateY(16px)',
      transition: reduce ? `opacity 0.2s ease ${delay}s` : `opacity 0.5s cubic-bezier(0.23, 1, 0.32, 1) ${delay}s, transform 0.5s cubic-bezier(0.23, 1, 0.32, 1) ${delay}s`,
    }}>
      {children}
    </div>
  );
}